import { render, staticRenderFns } from "./GenreLocalizationForm.vue?vue&type=template&id=4a1d84fa&scoped=true&"
import script from "./GenreLocalizationForm.vue?vue&type=script&lang=js&"
export * from "./GenreLocalizationForm.vue?vue&type=script&lang=js&"
import style0 from "./GenreLocalizationForm.vue?vue&type=style&index=0&id=4a1d84fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d84fa",
  null
  
)

export default component.exports